import BaseEntity from '@/models/base/BaseEntity.model';

export default class ReclamoModel extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public descripcion: string;
    public telefono: string;
    constructor() {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.descripcion = '';
        this.telefono = '';
    }
}